/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SiteEscalationDTO } from './SiteEscalationDTO';
import type { SitePerformanceActivityDto } from './SitePerformanceActivityDto';

export type StudySiteProtocolsDto = {
    studySiteId: number;
    studySiteStatus: string;
    studySiteWarmTransfer: boolean;
    studySiteContactDetailsSharing: boolean;
    studySiteDistance: number;
    studySiteCode: string;
    protocol: string;
    sitePerformanceActivites: Array<SitePerformanceActivityDto>;
    siteEscalation: Array<SiteEscalationDTO>;
    responsiblePerson: string;
    capacity?: number;
    nac?: number;
    siteDeactivationReason?: StudySiteProtocolsDto.siteDeactivationReason;
    siterxOptin: boolean;
    seqsterOptin?: boolean;
}

export namespace StudySiteProtocolsDto {
    export enum siteDeactivationReason {
        PATIENT_BACKLOG = 'PATIENT_BACKLOG',
        UNABLE_TO_REACH = 'UNABLE_TO_REACH',
        CAPACITY_REACHED = 'CAPACITY_REACHED',
        ON_SITE_REQUEST = 'ON_SITE_REQUEST',
        SPONSOR_REQUEST = 'SPONSOR_REQUEST',
    }
}
